import { useContext, useEffect, useState } from "react";
import { Card, Col, Container, Jumbotron, Row } from "react-bootstrap";
import { FaCalendarAlt } from "react-icons/fa";
import { useParams } from "react-router"
import Get from "../../api/Get";
import { MY_APPOINTMENT } from "../../api/Routes";
import AcordionRespuestas from "../../components/patient/AcordionRespuestas";
import { authContext } from "../../context/AuthContext";
import moment from 'moment'
import LoadingList from "../../loader/LoadingList";
import ReactPaginate from "react-paginate";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { withTranslation } from "react-i18next";
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever";

function MisRespuestaUsuario({t}){
    const {id} = useParams();
    const {auth} = useContext(authContext)
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)
    const postsPerPage = 10;

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;

    //server
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        setLoading(true)
        Get({url: `${MY_APPOINTMENT}/${id}`, access_token: auth.data.access_token})
        .then(response=>{
            let respuesta = response.data.data.response
            let pC = Math.ceil(respuesta.filter(el=>el.answers.length > 0).length / postsPerPage)
            setPageCount(pC)
            setItems(respuesta.filter(el=>el.answers.length > 0))
            setLoading(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }   
        })
    }, [])

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected+1)
    }


    return(
        loading ? <><LoadingList texto={t('cargando')}/></> :
        <>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top-2">{t('mis_respuestas')}</h2>
                    {items.length > 0 && <label className="font-weight-bold text-secondary">{`${items[0].patientDTO.name} ${items[0].patientDTO?.middleName ?? ''} ${items[0].patientDTO.lastName} ${items[0].patientDTO?.seccondSurname ?? ''}`}</label>}
                </Col>
            </Row>
            {
                (items.length === 0 && !loading) &&
                <Row className="mt-5">
                    <Col>
                        <Jumbotron>
                            <Container>
                                <p className="text-center">{t('no_cuenta_con_respuestas')}</p>
                            </Container>
                        </Jumbotron>
                    </Col>
                </Row>
            }
            <Row>
                {
                    items.slice(indexOfFirstPost, indexOfLastPost).map((item, i)=>(
                        <Col xs="12" md="6" key={i}>
                            <Card className="shadow-1 mb-2">
                                <Card.Body>
                                    <span className="d-block font-size-08rem color-646D82"><FaCalendarAlt className="mb-1"/> {moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY HH:mm")} hrs</span>
                                    <ul className="lits-inline p-0 text-secondary">
                                        <li className='list-inline-item mr-5'><strong>{t('doctor')}: </strong>{item.scheduleDTO?.name_doctor}</li>
                                        <li className='list-inline-item'><strong>{t('especialidad')}: </strong> {item.scheduleDTO.doctor?.espcialityList[0].name}</li>
                                    </ul>
                                    <hr />
                                    <AcordionRespuestas item={item}/>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                }                
            </Row>
            {items.length > 0 && 
                <Row className="mt-5">
                    <Col>
                        <ReactPaginate
                            previousLabel={<RiArrowLeftSLine />}
                            nextLabel={<RiArrowRightSLine />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />
                    </Col>
                </Row>
            }
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    )
    



}

export default withTranslation()(MisRespuestaUsuario)